import { colors, FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'

function CustomDropDown({ title, errMsg, handleDDChange, name, ddArr, width, height, defaultValue, bgColor, fontSize, borderRadius,
    readOnly, needNone = true }) {
    const labelStyle = {
        color: errMsg ? colors.red[500] : "rgba(0, 0, 0, 0.8)",
        fontWeight: 500,
        fontSize: fontSize || 12,
        // width: labelwidth ? labelwidth : 500
    }
    return (

        <FormControl sx={{ width: width ? width : 500 }} fullWidth>
            {title && <Typography htmlFor={"dd-id"} style={labelStyle} component={'label'} sx={{ mb: 0.7 }}>{title}</Typography>}
            <Select
                onChange={handleDDChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                id="dd-id"
                defaultValue={defaultValue ? defaultValue : ""}
                disabled={readOnly}
                name={name}
                sx={{
                    height: height ? height : 45, backgroundColor: bgColor, fontSize: fontSize || 13,
                    borderRadius: borderRadius ? borderRadius : 10
                }}
            >
                {needNone && <MenuItem value=""><em>None</em></MenuItem>}
                {ddArr.map((i) => <MenuItem value={i.value || i.id} key={i.value || i.id}>{i.label || i.configName}</MenuItem>)}
            </Select>
            <FormHelperText style={{ color: colors.red[500], }}>{errMsg}</FormHelperText>
        </FormControl>
    )
}

export default CustomDropDown